import React from 'react';
import ReactMarkdown from 'react-markdown/with-html';

var ContentRenderer = function ContentRenderer(_ref) {
  var source = _ref.source,
      escapeHtml = _ref.escapeHtml,
      isEscapedHtml = _ref.isEscapedHtml;

  var htmlDecode = function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
  };

  var sourceToParse = isEscapedHtml ? htmlDecode(source) : source;
  return /*#__PURE__*/React.createElement(ReactMarkdown, {
    source: sourceToParse,
    escapeHtml: escapeHtml
  });
};

ContentRenderer.defaultProps = {
  escapeHtml: false,
  isEscapedHtml: false
};
export default ContentRenderer;